import { BaseURL } from "../../config/axios";
import { Pagination } from "@nextui-org/react";
import paginationHelper from "../../helper/paginationHelper";
import { Link } from "react-router-dom";

const Category = ({ painting, pagination, category, setCurrentPage, currentPage }) => {
    return (
        <>
            <div className="container" dir="rtl">
                <div className="text-center my-8">
                    {category?.header3 && <h3 className="title text-primary mb-6">{category?.header3}</h3>}
                    {category?.header4 && <h5 className="text-center text-red-900 mb-6">{category?.header4}</h5>}
                    <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 items-stretch w-full gap-3">
                        {!!painting.length && painting.map(p => {
                            return (
                                <div className="w-full col-span-1 p-1 pb-2">
                                    <div className="flex flex-col border rounded-lg bg-gray-100 border-gray-300 text-center h-full shadow-lg pb-4">
                                        <div className="py-2 grow">
                                            <Link to={`/product/${p.slug}`} className="centerOfParent overflow-hidden h-full w-full">
                                                <img className="max-w-full max-h-48 object-contain"
                                                    width={100} height={100}
                                                    layout='responsive'
                                                    style={{ width: '100%', height: '100%' }} // optional
                                                    src={BaseURL + p.images[0]?.path}
                                                    alt={p.title_persian} title={p.title_persian} />
                                            </Link>
                                        </div>
                                        <div className="p-2">
                                            <div className="text-lg text-primary font-bold">
                                                <Link className="line-clamp-1" to={`/product/${p.slug}`} title={p.title_persian}>{p.title_persian}</Link>
                                            </div>
                                            <hr className="my-2 border-gray-400" />
                                            <div>{p.artist?.title}</div>
                                            <br />
                                            <div className="text-sm">{p.year}</div>
                                            <hr className="mt-2 mb-6 border-gray-400" />
                                            <Link to={`/product/${p.slug}`}
                                                className="text-white bg-main focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">انتخاب تابلو</Link>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div dir="auto" className="centerOfParent mt-4">
                    {!!painting.length && pagination.current > 1 &&
                        <Pagination size='sm'
                            total={Math.ceil(pagination.current)}
                            color="primary"
                            page={currentPage}
                            onChange={(e) => { setCurrentPage(e); paginationHelper() }}
                            showControls
                        />}
                </div>
                <div className="my-4">
                    <div className={`text-justify ql-editor`} dangerouslySetInnerHTML={{ __html: category.body }} />
                </div>
            </div>

        </>
    );
};

export default Category;